var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9FCF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 24.8333H30.3226C30.7079 24.8333 30.9006 24.8333 31.0107 24.7525C31.1067 24.682 31.1679 24.5739 31.179 24.4553C31.1916 24.3194 31.0925 24.1541 30.8942 23.8237L29.2058 21.0097C29.131 20.885 29.0936 20.8226 29.079 20.756C29.066 20.6972 29.066 20.6362 29.079 20.5773C29.0936 20.5107 29.131 20.4484 29.2058 20.3237L30.8942 17.5097C31.0925 17.1792 31.1916 17.014 31.179 16.878C31.1679 16.7594 31.1067 16.6513 31.0107 16.5808C30.9006 16.5 30.7079 16.5 30.3226 16.5H17.3333L17.3333 31.5",
    stroke: "#17E28C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.8a6964f42d38c60a5c3e5002b7338435.svg";
export { ForwardRef as ReactComponent };